module.exports = "<p>Vous êtes déconnecté.Redirection en cours</p>\r\n"